import { useTranslation } from 'react-i18next';
import { Box, styled } from '@mui/material';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { TextV2 } from '@insights-ltd/design-library/components';
import { PRIVACY_POLICY_URL } from 'variables';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import InsightsLogo from 'components/Svgs/ASSET-InsightsLogoWhite.svg';
import Background from './ASSET-self-service-background.svg';

const Wrapper = styled('div')({
  width: '100vw',
  height: '100vh',
  overflow: 'scroll',
});

const StyledDiv = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  height: '4rem',
  marginBottom: '1rem',
});

const StyledP = styled(TextV2)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '4rem',
  marginBottom: '17px',
});

const SelfServiceLayout = ({ children }: any) => {
  const { t } = useTranslation();
  const currentYear = new Date().getUTCFullYear();

  return (
    <Wrapper>
      <Grid
        container
        wrap="nowrap"
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: `calc(100% - 4rem)`,
          backgroundImage: `url("${Background}")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <Grid
          container
          sx={{
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box
            sx={(theme) => ({
              flexShrink: '0',
              margin: `${theme.spacing(spacingSizeMap.S)} 0 ${theme.spacing(
                spacingSizeMap.S,
              )} 0`,
            })}
          >
            <img
              alt={t('ui.io.profile.discovery.footer.logo_title')}
              src={InsightsLogo}
              width="178px"
              height="48px"
            />
          </Box>
          {children}
        </Grid>
      </Grid>
      <StyledDiv>
        <StyledP component="p" variant="bodySmall" color="textSecondary">
          {t('ui.event-management.copyright-message', { currentYear })}
        </StyledP>
        <Link
          sx={{ fontSize: '14px' }}
          color="primary"
          href={PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener"
        >
          {t('ui.event-management.footer.our-privacy-notice')}
        </Link>
      </StyledDiv>
    </Wrapper>
  );
};

export default SelfServiceLayout;
